{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [1]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "icing"
		},
		{
			"children": [0],
			"mesh": 1,
			"name": "donut",
			"translation": [0, 0.039157040417194366, 0]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.001",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.6987370848655701, 0.23136168718338013, 0.8007099628448486, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.27868854999542236
			}
		},
		{
			"doubleSided": true,
			"name": "Material.002",
			"pbrMetallicRoughness": {
				"baseColorTexture": {
					"index": 0
				},
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		}
	],
	"meshes": [
		{
			"name": "Torus.001",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				}
			]
		},
		{
			"name": "Torus",
			"primitives": [
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 7,
					"material": 1
				}
			]
		}
	],
	"textures": [
		{
			"sampler": 0,
			"source": 0
		}
	],
	"images": [
		{
			"mimeType": "image/png",
			"name": "donut base",
			"uri": "donut%20base.png"
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 26984,
			"max": [0.6714563965797424, 0.2770253121852875, 0.6741597652435303],
			"min": [-0.6780579686164856, -0.2085205763578415, -0.6691431999206543],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 26984,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 26984,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 161280,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 429,
			"max": [0.6617754697799683, 0.2676566541194916, 0.6673516631126404],
			"min": [-0.6719720363616943, -0.25, -0.6622211337089539],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 429,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 429,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5123,
			"count": 2304,
			"type": "SCALAR"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 323808,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 323808,
			"byteOffset": 323808,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 215872,
			"byteOffset": 647616,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 322560,
			"byteOffset": 863488,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 5148,
			"byteOffset": 1186048,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 5148,
			"byteOffset": 1191196,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 3432,
			"byteOffset": 1196344,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 4608,
			"byteOffset": 1199776,
			"target": 34963
		}
	],
	"samplers": [
		{
			"magFilter": 9729,
			"minFilter": 9987
		}
	],
	"buffers": [
		{
			"byteLength": 1204384,
			"uri": "donut.bin"
		}
	]
}
